<template lang="pug">
form.flex.flex-col.gap-8.w-full
  p.flex.gap-4.w-full 
    input.rounded.px-4.text-lg.w-80(
      :class="valid ? 'ring-1 ring-gray-500 focus_ring-2 focus_ring-sky-500' : 'ring-4 focus_ring-6 ring-red-700'"
      v-model="value"
    )

    uc-button.btn.ripple.min-w-0.px-6.disabled_opacity-20(
      :disabled="!valid"
      @click="play"
    ) Play

  .flex.flex-wrap.gap-4.mx-auto(
    class="w-[23rem]"
    ref="elRef"
    style="perspective: 1000px"
  )
    uc-animate.h-20.w-20.inline-block.bg-primary-900.corners(
      :animate="animate"
      :key="animate"
      v-for="i in 8"
    )
</template>

<script setup lang="ts">
import gsap from 'gsap';
import { nextTick, ref, computed, onMounted, watchEffect } from 'vue';
import validate from '../lib/validateAnimate';

const props = defineProps<{ screen: UcScreen }>();
const value = ref(props.screen.animate);
const elRef = ref<AnimatedElement>();

const animate = ref(props.screen.animate);
const valid = computed(() => validate(value.value));

let demoTl: GSAPTimeline;

const play = () => {
  value.value = value.value + ' ';

  nextTick(() => {
    value.value = value.value?.trim();
  });
};

// const play = async () => {
//   if (demoTl) demoTl.play(0);
// };

let playCount = ref(0);

const init = async () => {
  const v = value.value;
  if (!v || !validate(v)) return;
  animate.value = v;

  await nextTick();
  await nextTick();

  const els = elRef.value.querySelectorAll<AnimatedElement>('.uc-animate');

  // if (demoTl) demoTl.kill();
  // demoTl = gsap.timeline({ paused: true });

  // els.forEach((el, i) => {
  //   demoTl.add(gsap.set(null, { onStart: () => el.play() }), i * 2);
  // });

  // demoTl.play(0);

  // play = () => {
  playCount.value++;
  const thisPlayCount = playCount.value;
  // gsap.set(els, { opacity: 0, overwrite: 'auto' });
  els.forEach((el, i) => {
    el.reset();
    setTimeout(
      () => {
        // cancel if the button was clicked again
        if (thisPlayCount === playCount.value) el.play();
      },
      100 + i * 200
    );
  });
  // };

  // play();
};

onMounted(init);
watchEffect(init, { flush: 'post' });
</script>
